<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="可选项类型" prop="name">
        <el-input v-model="dataForm.type" placeholder="类型"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="名称"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        type: 0,
        name: ''
      },
      dataRule: {
        name: [
          {required: true, message: '名稱不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.dataForm.type = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.type) {
          this.$http({
            url: this.$http.adornUrl(`/configOption/type/list`),
            method: 'get',
            params: this.$http.adornParams()
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/configOption/type/${!this.dataForm.type ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'type': this.dataForm.type || undefined,
              'name': this.dataForm.name
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
            this.$message({
              message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/configoptiontype-add-or-update.vue